import type { AdminJsonComponentConfig } from './types';
import { ThingsToDoConfig } from '@website-custom-components/ThingsToDo/ThingsToDo.config';
import { DefaultThingsToDoConfig } from '@website-custom-components/DefaultThingsToDo/DefaultThingsToDo.config';
import { GeneralScheduleConfig } from '@website-custom-components/GeneralSchedule/GeneralSchedule.config';
import { FormDisplayConfig } from '@website-custom-components/FormDisplay/FormDisplay.config';
import { VipConfig } from '@website-custom-components/Vip/Vip.config';
import { WeatherReportConfig } from '@website-custom-components/WeatherReport/WeatherReport.config';
import { FaqConfig } from '@website-custom-components/Faq/Faq.config';
import { PlaceToStayConfig } from '@website-custom-components/PlaceToStay/PlaceToStay.config';
import { EventCountdownConfig } from '@website-custom-components/EventCountdown/EventCountdown.config';
import { RsvpBlockConfig } from '@website-custom-components/RsvpBlock/RsvpBlock.config';
import { StayBookingAssistantConfig } from './customComponents/StayBookingAssistant/StayBookingAssistant.config';
import { GraphicAccentConfig } from '@website-custom-components/GraphicAccent/GraphicAccent.config';
import { EventDetailsConfig } from '@website-custom-components/EventDetails/EventDetails.config';

// Add all your custom components here so they can be picked up and rendered.
// NOTE: The rendering order matters - components appear in the "Add Component" list
// in the admin interface in the same order as defined here. This order determines
// the visual priority and display sequence when users are selecting components to add.
export const CUSTOM_JSON_COMPONENT_TYPES: ReadonlyArray<AdminJsonComponentConfig> = [
  PlaceToStayConfig,
  StayBookingAssistantConfig,
  ThingsToDoConfig,
  DefaultThingsToDoConfig,
  GeneralScheduleConfig,
  FormDisplayConfig,
  VipConfig,
  WeatherReportConfig,
  FaqConfig,
  EventCountdownConfig,
  RsvpBlockConfig,
  GraphicAccentConfig,
  EventDetailsConfig,
];
